declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';
import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';

@Component({
  selector: 'actordocs2',
  templateUrl: './actordocs2.modal.html',
  styleUrls: ['./actordocs2.modal.scss']
})

export class NgbActorDocs2Modal implements OnInit {
    //@Input() DocTitle: string;
   // @Input() DocType:string;
    @Input() ActorCode:number;
  @Input() ActorDocCode : number;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;

  @Input() CanEdit: number;
  @Input() CanShow: number;



  file: File;
  fileList: FileList;



  FileExtension: string = "";
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  DocFriendlyName: string = "";
  CurrentActorDocRequest: ActorDocRequest;
  CurrentDownloadFileRequestRequest: DownloadFileRequest;

  CurrentActorDocController: ActorDocController[];

  @ViewChild('f') IdentitiesDocForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number =0 ;



  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService) { }
  ngOnInit() {

      this.CurrentActorDocRequest = new ActorDocRequest();
      this.CurrentActorDocRequest.ActorCode = this.ActorCode;
    this.CurrentActorDocRequest.EntryActorCode = AppData.Instance().UserLoginDetails.ActorCode;
      this.CurrentActorDocRequest.ActorDocCode = this.ActorDocCode;
    this.CurrentActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    if (AppData.Instance().UserLoginDetails.ActorType === 3) {
      this.CanDownLoadActorDoc = 0;
      this.CanNurseView = 1;
    }
    else {
      this.CanDownLoadActorDoc = 1;
      this.CanNurseView = 0;
    }

    this.CurrentActorDocController = new Array<ActorDocController>();

    this.CurrentDownloadFileRequestRequest = new DownloadFileRequest();
    this.CurrentDownloadFileRequestRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    //this.GetActorDocController();

  }



  fileChange(event: any) {
    this.StartRefreshing();
    this.fileList = event.target.files;
    this.stopRefreshing();
  }



  onSubmit() {
      this.CurrentActorDocRequest.DocFriendlyName = this.DocFriendlyName;
      this.CurrentActorDocRequest.DocType = this.DocFriendlyName;
      this.CurrentActorDocRequest.DocTitle = this.DocFriendlyName;
    this.CurrentActorDocRequest.ConditionalOperator = 1;
    //  console.log('onSubmit------------------------------------>' )
    this.StartRefreshing();

    if (this.fileList != null && this.fileList.length > 0) {
      this.file = this.fileList[0];
      var size = (parseFloat(this.file.size.toString()) / 1024).toFixed(2);
      console.log('this.file.type1--->' + size);
      if (parseFloat(size) > 1 * 1024) {
        this.stopRefreshing();
        //console.log('this.file.type2--->' + size);
        alertFunctions.AlertParam("Upload  files will allow Up to 1*1024 KB(1MB) only ...! this file is " + size + " KB.");
      }
      else {
       // console.log('this.file.type3--->' + size);


        let formData: FormData = new FormData();
        formData.append('actordoc', this.file, this.file.name);
        this.FileExtension = this.file.name.substring(this.file.name.lastIndexOf("."));
          this.CurrentActorDocRequest.DocFileExtension = this.FileExtension;
        
        this.docservice.xUploadActorDocs4(formData, this.CurrentActorDocRequest)
            .subscribe(result => {
                this.ApiResData = result;
if (!this.ApiResData.hasError) {

                if (this.ApiResData.Result > 0) {

                    // alertFunctions.AlertParam('Save Successfully.....!');
                    this.tosterservice.ToasterSuccessAlertParam('Uploaded Successfully.....!');


                    this.activeModal.close();
                    this.stopRefreshing();

                }
                else {
                    alertFunctions.AlertParam("Invalid Operation...!");
                    this.stopRefreshing();

                }

            }
            else {
                this.stopRefreshing();
                if (this.ApiResData.ErrorData != "") {

                    alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                }
                else {
                    alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                }
            }

        },

          (error) => {
            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);
              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParamEr(error);
              this.stopRefreshing();
            }
          }
          );


      }
    }
    else {
        alertFunctions.AlertParam('No files exits to Upload...!');
        this.stopRefreshing();
      }
    
  }




  GetActorDocController() {
    this.StartRefreshing();
    this.docservice.GetActorDocController(this.CurrentActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentActorDocController = this.ApiResData.Result;
          this.initGridButton();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start
  isREADONLY: boolean = false;
  exportFileName: string = "ActorDocList_";
  dbops: DBOperation;
  columns: any[] = [

    {
      display: 'Document Name',
      variable: 'DocFriendlyName',
      filter: 'text'
    },
    {
      display: 'Uploaded Date',
      variable: 'DocCaptureDate',
      filter: 'date'
    }
    //,
    //{
    //  display: 'Date of Birth',
    //  variable: 'DOB',
    //  filter: 'date'
    //}
  ];
  sorting: any = {
    column: 'SeqNo',
    descending: false
  };
  hdrbtns: any[] = [];
  gridbtns: any[] = [];
  initGridButton() {

    this.hdrbtns = [
      {


      }];
    this.gridbtns = [
      {
        title: 'Remove',
        keys: ["ActorDocPageCode"],
        action: DBOperation.delete,
        ishide: false
      },

      {
        title: 'Download',
        keys: ["ActorDocPageCode"],
        action: DBOperation.doc,
        ishide: false
      },

    ];

  }
  //Grid Vars end
  gridaction(gridaction: any): void {

    switch (gridaction.action) {
      case DBOperation.doc:
        // alertFunctions.AlertParam(gridaction.values[0].value);
        this.DownloadActorDoc(gridaction.values[0].value)
        break;
      case DBOperation.delete:
        // alertFunctions.AlertParam(gridaction.values[0].value);
       
        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0CC27E',
          cancelButtonColor: '#FF586B',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonClass: 'btn btn-success btn-raised mr-5',
          cancelButtonClass: 'btn btn-danger btn-raised',
          buttonsStyling: false
        }).then(() => {



          this.DeleteActorDoc(gridaction.values[0].value);

        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              'Delete Operation Cancelled :)',
              'error'
            )
          }
        }) 
        break;
    }
  }


  del_(ActorDocPageCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorDoc(ActorDocPageCode);
     // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }


  ///////////
  public DownloadActorDoc(ActorDocPageCode: number) {
    var DownloadActorDocPageCode = this.CurrentActorDocController.filter(x => x.ActorDocPageCode = ActorDocPageCode)

    if (DownloadActorDocPageCode.length > 0) {


      this.CurrentDownloadFileRequestRequest.DBFileName = DownloadActorDocPageCode[0].DocID; //"4e51623b-e1d8-49bf-aa23-a4ef4e9d1dc0";
      this.CurrentDownloadFileRequestRequest.folderType = "ActorDocuments"; //"patientDocuments";
      this.CurrentDownloadFileRequestRequest.ActorCode = DownloadActorDocPageCode[0].ActorCode;//35631;
      this.CurrentDownloadFileRequestRequest.FileExtension = DownloadActorDocPageCode[0].DocFileExtension   // '.pdf'
      this.CurrentDownloadFileRequestRequest.FriendlyFileName = DownloadActorDocPageCode[0].DocFriendlyName;
      // console.log('FileExtension-->'+this.CurrentDownloadFileRequestRequest.FileExtension);
      this.docservice.xDownloadDoc(this.CurrentDownloadFileRequestRequest)
    }
    else {
      alertFunctions.AlertParam("No file Exit...!");
    }


  }


  public DeleteActorDoc(ActorDocPageCode: number) {
    if (this.CanEdit === 1) {
      this.StartRefreshing();
      this.CurrentActorDocRequest.ActorDocPageCode = ActorDocPageCode;
      this.CurrentActorDocRequest.ConditionalOperator = 3;
      this.docservice.SaveActorDocs(this.CurrentActorDocRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            if (this.ApiResData.Result > 0) {

             // alertFunctions.AlertParam('Save Successfully.....!');
              this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');


              this.GetActorDocController();
              this.stopRefreshing();

            }
            else {
              alertFunctions.AlertParam("Invalid Operation...!");
              this.stopRefreshing();

            }

          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }

        },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
        );
    }
    else {
      alertFunctions.AlertParam('Access Denied...!');
    }
  }













  /////////////////////////
}
